
import Vue from "vue";
import notifications from "@/lib/notifications";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { AgentResource, AgentDeliveryForResource } from "../../models/api/system/agents";
import SystemModule from "@/store/modules/system";
import { getModule } from "vuex-module-decorators";
import AgentUsers from "../../views/admin/AgentUsers.vue";
import UserEditModal from "./UserEditModal.vue";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    AgentUsers,
    UserEditModal
  }
})
export default class UsersTab extends Vue {
  @Prop()
  public wantCallbacks: boolean;

  @Prop()
  public agent: AgentResource;

    getAgentId() {
        let agentId = this.agent==null ? 0 : this.agent.id ?? 0;
        return agentId;
    }    

    UserUpdated() {
        const tab = this.$refs.userTab as AgentUsers;
        tab.updateUsers();
    }

  onEditUserClicked(id) {
    const modal : UserEditModal = this.$refs.userModal as UserEditModal;
    modal.show(id);
  }
}
